import { render, staticRenderFns } from "./navigationGroupBlock.vue?vue&type=template&id=2f32253a&"
import script from "./navigationGroupBlock.vue?vue&type=script&lang=js&"
export * from "./navigationGroupBlock.vue?vue&type=script&lang=js&"
import style0 from "./navigationGroupBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports